import React from "react";
import ProgressBar from "./ProgressBar";
import ProgressText from "./progressText.json";
import ProgressTextiACST from "./progressTextiACST.json";
import ProgressTextIAT from "./progressTextIAT.json"
import ProgressTextAKTHE from "./progressTextAKTHE.json"
import config from "../config";
function AntheResultPage2({ Response, exam_type }) {
  const segments = [
    { name: "Segment A", percentage: 30, color: "#D9D9D9" },
    { name: "Segment B", percentage: 30, color: "#FE9085" },
    { name: "Segment B", percentage: 25, color: "#AEDBF1" },
    { name: "Segment C", percentage: 5, color: "#FCBE23" },
    { name: "Segment D", percentage: 10, color: "#97E3DC" },
  ];
  const locationPercentage = Response.percentage;
  return (
    <div style={{ fontFamily: "Outfit-Medium" }}>
      <div className="mb-5">
        <h1 className="fw-bold text-dark-magenta mb-4">
          DETAILED RESULT ANALYSIS IN{" "}{exam_type === "iACST" ? "iACST 2026" : exam_type === "IAT" ? "IAT 2026" : !Response.profile.anthetwo ? `ANTHE ${config.YEAR}` : "ANTHE 2.0"}
          {exam_type === "AKTHE" ? "-KASHMIR" : null}
        </h1>
      </div>
      <div className="mt-5">
        <h3 className="text-center text-light-blue-100 font-size-xxl fw-bold mb-0 mt-4">
          YOUR LEVEL OF PREPARATION
        </h3>
        <p className={`text-center text-light-grey-200 font-size-xxl ${exam_type === 'iACST' || exam_type === 'IAT' ? 'fw-normal' : 'fw-bold'} `}>
          Based on your Percentage of Marks
        </p>
      </div>

      <ProgressBar
        segments={segments}
        locationPercentage={locationPercentage}
      />
      <p
        style={{ fontFamily: "Outfit-Regular" }}
        className="text-start font-size-md"
      >
        {Response.performance}:
        {exam_type === "iACST"
          ? ProgressTextiACST[Response.profile.stream][Response.performance]
          : exam_type === "IAT"
            ? ProgressTextIAT[Response.profile.stream][Response.performance]
            : exam_type === "AKTHE"
              ? ProgressTextAKTHE[Response.profile.stream][Response.performance]
              : ProgressText[Response.profile.stream][Response.performance]}
      </p>
    </div >
  );
}

export default AntheResultPage2;
